<div class="child-contact-info">
  <div class="child-contact-info-icon">
    <se-fe-icon
      seFeDataName="spot_jersey"
      seFeDataSize="950"
      seFeDataAriaLabel="child">
    </se-fe-icon>
  </div>
  <div class="child-contact-info-title">
    <se-po-highlight-label
      label="Child's Info"
      theme="child">
    </se-po-highlight-label>
  </div>
  <div *ngIf="ready" class="child-contact-info-heading">
    <h1>
      Would you like to add contact information for {{ persona.first_name }}?
    </h1>
    <p *ngIf="description">
      {{ description }}
    </p>
  </div>
  <div role="content" class="child-contact-info-content">
    <div *ngIf="!ready">
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
    <form
      *ngIf="ready"
      [formGroup]="form"
      novalidate>
      <se-po-child-contact-info
        *ngIf="ready"
        [persona]="persona"
        formControlName="contactInfo"
      ></se-po-child-contact-info>
    </form>
  </div>
</div>
